import React, { CSSProperties, forwardRef, useEffect, useState } from 'react';
import Icon from '~/core/ui/Icon';

interface CtcProps {
  ref: React.RefObject<HTMLElement>;
}

export const footerButtonClass =
  'flex flex-col space-x-2 items-center justify-center w-6 h-6 hover:bg-secondary hover:text-black rounded-full cursor-pointer p-4';

const CopyToClipboard = forwardRef<HTMLElement, CtcProps>((props, ref) => {
  const [clipboardSupported, setClipboardSupported] = useState(false);
  const [copyFeedback, setCopyFeedback] = useState('');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setClipboardSupported(!!navigator.clipboard);
    setIsLoading(false);
  }, []);

  const handleCopy = async () => {
    if (!ref || !('current' in ref) || !ref.current) {
      return;
    }

    try {
      console.log('ref:', ref);
      const textContent = ref.current?.textContent;
      if (!textContent) {
        return;
      }
      await navigator.clipboard.writeText(textContent);
      setCopyFeedback('Copied message!');
      setTimeout(() => setCopyFeedback(''), 3000);
    } catch (error) {
      console.error('Error copying', error);
    }
  };

  const alertStyle = {
    opacity: copyFeedback ? '1' : '0',
    transform: copyFeedback ? 'translateY(0)' : 'translateY(0.25em)',
    transition: 'opacity 200ms, transform 200ms',
    position: 'absolute',
    bottom: 'calc(100% + 0.5em)',
    fontSize: '0.75rem',
    fontWeight: 'bold',
    lineHeight: '2.5',
    textAlign: 'center',
    whiteSpace: 'nowrap',
    borderRadius: '0.25em',
    minWidth: '130px',
    padding: '0.25em',
    zIndex: 1,
  } as CSSProperties;

  const buttonStyle = 'flex items-center font-medium rounded';

  if (isLoading) {
    return null;
  }

  return (
    <div className={footerButtonClass} style={{ gap: 'var(--space-2)' }}>
      {clipboardSupported && (
        <div className="relative h-full flex">
          <button className={buttonStyle} onClick={handleCopy}>
            <Icon
              icon="ic:baseline-content-copy"
              width="1rem"
              className="flex items-center justify-center h-full"
            />
          </button>
          <p
            className="alert w-full bg-secondary text-black"
            style={alertStyle}
          >
            {copyFeedback}
          </p>
        </div>
      )}
    </div>
  );
});

export default CopyToClipboard;
